export default __webpack_public_path__ + "eda8b94308c6f538f04a8056ed761a57.ttf";